import { Box, Button, Card, CardContent, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";



const HeroSection = () => {
    return (
        <Box sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            height: 'calc(100vh - 70px)',
            overflow: 'hidden',
            backgroundImage: `
                linear-gradient(
                    to bottom, 
                    #ebeef3 0%, 
                    #ebeef34f 30%, 
                    #6841f24f 95%
                )`,
        }}>
            {/* Main Content */}
            <Box textAlign="center" sx={{
                marginTop: '25vh',
                paddingBottom: '10vh',
                marginLeft: '60px',
                marginRight: '60px',

                '@media (max-width: 750px)': {
                    marginTop: '10vh',
                },
            }}>
                <Box sx={{ textAlign: 'center' }}>
                    <Typography sx={{ 
                        fontFamily: 'Red Rose', 
                        textTransform: 'none', 
                        fontWeight: '400', 
                        fontSize: '64px', 
                        lineHeight: '80%',
                        color: '#3B0E59',

                        '@media (max-width: 600px)': {
                            fontSize: '48px',
                        },
                        '@media (max-width: 400px)': {
                            fontSize: '36px',
                        }
                    }}>
                        We Are <span style={{ color: '#6841f2' }}>NumaSuite</span>
                    </Typography>
                </Box>

                {/* Use Subheading */}
                <Box sx={{ textAlign: 'center' }}>
                    <Typography sx={{ 
                        fontFamily: 'Raleway', 
                        textTransform: 'none', 
                        fontSize: '20px', 
                        color: '#212529',

                        marginTop: '30px',

                        '@media (max-width: 600px)': {
                            fontSize: '16px',
                            marginTop: '20px',
                        },
                    }}>
                        UK based all-in-one business management software.
                    </Typography>
                    <Typography sx={{
                        fontFamily: 'Raleway',
                        textTransform: 'none',
                        fontSize: '20px',
                        color: '#212529',

                        maxWidth: '780px',

                        marginTop: '0px',

                        '@media (max-width: 600px)': {
                            fontSize: '16px',
                            marginTop: '10px',
                        },
                    }}>
                        We provide a range of services to help you manage your business.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const HowDidWeStart = () => {
    return (
        <Container maxWidth="lg">
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                marginTop: '15vh',
                marginBottom: '15vh',
                
                padding: "16px",
                paddingLeft: "32px",
                paddingRight: "32px",
                position: "relative",
                
                "&::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    width: "4px",
                    height: "100%",
                    transform: "translateY(-50%)",
                    background: 'linear-gradient(90deg, #9c27b0 0%, #6a1b9a 100%)',
                    borderRadius: "2px"
                }
            }}>
                <Typography sx={{
                    fontFamily: 'Red Rose',
                    textTransform: 'none',
                    fontSize: '36px',
                    color: '#3B0E59',
                    marginBottom: '20px',
                }}>
                    How Did We Start?
                </Typography>
                <Typography sx={{
                    fontFamily: 'Raleway',
                    textTransform: 'none',
                    fontSize: '20px',
                    color: '#212529',
                    maxWidth: '800px',
                    textAlign: 'left',
                }}>
                    We saw a gap in the market for a business management software that was easy to use and affordable. We wanted to create a platform that would help businesses of all sizes manage their operations more efficiently.
                </Typography>
            </Box>
        </Container>
    );
};

const WhatDoWeBring = () => {

    const operationPoints = [
        {
            title: "Unlimited Scaling",
            description: "Our platform is designed to grow with your business, so you can scale up without any limitations",
            ariaLabel: "Scalability information"
        },
        {
            title: "Enhanced Security",
            description: "We use the latest security protocols to keep your data safe and secure at all times",
            ariaLabel: "Security information"
        },
        {
            title: "Inbuilt Auditing",
            description: "Our platform includes auditing features to help you keep track of all your business activities",
            ariaLabel: "Auditing information"
        }
    ];

    return (
        <Container sx={{
            textAlign: 'center',
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontSize: '36px',
                color: '#3B0E59',
                marginBottom: '20px',
            }}>
                What Do We Bring?
            </Typography>
            <Grid container spacing={4}>
                {operationPoints.map((point, index) => (
                    <Grid item xs={12} md={4} key={index}>
                        <Card
                            elevation={3}
                            aria-label={point.ariaLabel}
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                                "&:hover": {
                                    transform: "translateY(-8px)",
                                    boxShadow: '0 4px 12px 0 rgba(0,0,0,0.2)'
                                },
                                background: "linear-gradient(145deg, #f4f4f6 0%, #ffffff 100%)",
                                boxShadow: '0 4px 12px 0 `rgba(0,0,0,0.1)`'
                            }}
                        >
                            <CardContent sx={{ textAlign: "center", p: 4 }}>
                                <Typography
                                    fontFamily="Red Rose"
                                    fontSize="24px"
                                    component="h3"
                                    color="#1e1559"
                                    gutterBottom
                                    sx={{ 
                                        fontWeight: 600,
                                        lineHeight: 1.1,
                                        '@media (max-width: 600px)': {
                                            fontSize: '20px',
                                        },
                                    }}
                                >
                                    {point.title}
                                </Typography>
                                <Typography
                                    fontFamily="Raleway"
                                    fontSize="18px"
                                    color="text.secondary"
                                    sx={{ 
                                        lineHeight: 1.7,
                                        '@media (max-width: 600px)': {
                                            fontSize: '16px',
                                        },
                                    }}
                                >
                                    {point.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

const ContactUs = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '15vh',
            marginBottom: '15vh',

            paddingLeft: '15px',
            paddingRight: '15px',
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontSize: '36px',
                color: '#3B0E59',
                marginBottom: '20px',
            }}>
                Contact Us
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '20px',
                color: '#212529',
                maxWidth: '800px',
                textAlign: 'center',
                marginBottom: '20px',
            }}>
                If you have any questions or would like to know more about our services, please get in touch. We would love to hear from you.
            </Typography>
            <Button variant="contained" sx={{
                backgroundColor: '#6841f2',
                color: '#fff',
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '16px',
                borderRadius: '5px',
                padding: '5px 20px',
                marginTop: '45px',

                boxShadow: 'none',

                '@media (max-width: 600px)': {
                    marginTop: '30px',
                }
            }} onClick={ () => navigate('/contact-us') }>Talk to Us</Button>
        </Box>
    );
};



export default () => (
    <>
        <HeroSection />

        <Box sx={{
            width: '100%',
            maxWidth: '900px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}>
            <Box sx={{
                paddingLeft: '35px',
                paddingRight: '35px',
            }}>
                <HowDidWeStart />
                <WhatDoWeBring />
            </Box>
        </Box>

        <ContactUs />
    </>
);